import { create } from 'zustand';

export const useModuleStore = create((set /*get*/) => ({
	setServiceRequest: (serviceRequest) => set({ serviceRequest }),
}));
